import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@mui/material'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import clsx from 'clsx'
import { CTA_VARIANTS } from '../Sections.const'

const CallToAction = ({ variant = CTA_VARIANTS.VARIANT_1, Element }) => {
	const metaData = useSectionMetaData()

	return (
		<Box className={clsx(variant, 'section-cta')}>
			<Container className="section-cta-content">{Element && <Element metaData={metaData} />}</Container>
		</Box>
	)
}

CallToAction.propTypes = {
	variant: PropTypes.oneOf(Object.values(CTA_VARIANTS)),
	Element: PropTypes.elementType,
}

export default memo(CallToAction)
